import IconLogoPerson2 from "assets/svg/IconLogoPerson2.svg";
import IconLogoBank from "assets/svg/IconLogoBank.svg";
import IconLogoCashier from "assets/svg/IconLogoCashier.svg";
import IconLogoFund from "assets/svg/IconLogoFund.svg";
import IconLogoCheque from "assets/svg/IconLogoCheque.svg";
import ChequeImage from "assets/svg/ChequeImage.svg";
import posImg from "assets/svg/pos.svg";
import ChequeGreenImage from "assets/svg/ChequeGreenImage.svg";
import autograph from "assets/svg/autograph.svg";
import { useDispatch, useSelector } from "react-redux";
import { ReactNode, useEffect, useState } from "react";
import BasicButton from "components/BasicInputs/BasicButton";
import { apiFinancialsList } from "api/financialApi";
import { apiPersonsList } from "api/personApi";
import { appSetModal } from "store/actions/appAction";
import PlusIcon from "assets/icons/PlusIcon";
import Card, { CardProps } from "./Card";
import { formatPrice, setSelectItemLabels } from "helpers";
import HashtagIcon from "assets/icons/Hashtag";
import { ClickAwayListener } from "@mui/material";
import { apiChequesList } from "api/chequeApi";
import avatar from "assets/images/AvatarIcon.svg";

import useCurrency from "helpers/useCurrency";
import { apiGetPos } from "api/PosApi";

export interface DestinationCardProps {
  onChange?: (data: any) => void;
  onChangeEdit?: CardProps["onChangeEdit"];
  onDelete?: (index: number) => void;
  index?: number;
  defPrice?: number;
  currency?: Currency;
  info?: CardProps["info"];
  edit?: boolean;
  justShow?: boolean;
  data?: any;
  type?: string;
  tab?: number;
  variant?: number;
  transactionType?: "receive" | "payment";
  activeOption?: string[];
  extraFooterBtn?: ReactNode
  installmentOption?: boolean;
  transactionsPrice?: number
  totalPrice?: number
}

export default function DestinationCard(props: DestinationCardProps) {



  const { transactionsPrice, defPrice, totalPrice } = props
  const dispatch: any = useDispatch();
  const { extraFooterBtn } = props

  const { defCur, currencies } = useCurrency();
  const DefaultTransAction = useSelector((state: any) => state.appReducer?.appSettings?.DefaultTransAction);
  const token = useSelector((state: any) => state.businessReducer?.business?.token)
  const { banks, funds, cashiers } = useSelector((state: any) => state.financialReducer);
  // const { allPerson }: { allPerson: Person[] } = useSelector((state: any) => state.personReducer);
  const [allPerson, setAllPerson] = useState([])
  const cheques: Cheque[] = useSelector((state: any) => state.chequeReducer.cheques) || [];
  const [posList, setPosList] = useState<any[]>([])
  const [type, setType] = useState(props.type || DefaultTransAction || "bank");
  const [data, setData] = useState<any>(props.data || { price: props.defPrice });
  const [edit, setEdit] = useState(props.edit);
  const [defaultValues, setDefaultValues] = useState({ selectPersonDes: 0 })
  useEffect(() => setData(props.data || { price: props.defPrice }), [props.data]);
  useEffect(() => setType(props.type || DefaultTransAction || "bank"), [props.type]);
  useEffect(() => setType(props.type || DefaultTransAction || "bank"), [props.type]);
  useEffect(() => {
    dispatch(apiGetPos(token, (res: any) => {
      const list: any[] = normalize(res.data.pos)
      setPosList(list)
    }))
    if (allPerson.length === 0) {
      dispatch(apiPersonsList(token, "allPerson", (res: any) => {
        setAllPerson(res)
      }))
    }
  }, []);
  const chequePayers = {
    receive: normalize(allPerson),
    payment: normalize(banks)
  };
  const defaultPos: any = posList.find((x: any) => x.default)
  const chequeRefreshList = {
    receive: () => dispatch(apiPersonsList(token, "allPerson")),
    payment: () => dispatch(apiFinancialsList("bank", token))
  };
  const beforeLoadingPerSelectBox: BasicSelectProps["beforeLoadingPerSelectBox"] = ({ name, params, status }) => {
    switch (name) {
      case "selectPersonDes":
        if (status === "beforeSendRequest") {
          params["personType"] = "allPerson"
          return params
        } else {
          const persons = setSelectItemLabels(params.persons, "id", "nickName");
          return persons.map((x: any) => ({
            ...x,
            image: x.avatar || avatar,
            dsc: `${x.mobile || ""}`,
            ind: x.accountingCode,
            title: x.nickName
          }))
        }
    }
  }
  const inputs: CardProps["inputs"] = {
    bank: {
      type: "select",
      label: "انتخاب بانک",
      options: normalize(banks),
      withSearch: true,
      withRefresh: true,
      refreshList: () => dispatch(apiFinancialsList("bank", token)),
      footer: (
        <Footer
          title="افزودن بانک"
          type="financial"
          callBack={(token: any, res: any) => {
            dispatch(
              apiFinancialsList("bank", token, () => {
                handleChange({ key: "bank", val: res.id });
              })
            );
          }}
        />
      ),
      closeOnFooterClick: true
    },
    fund: {
      type: "select",
      label: "انتخاب تنخواه",
      options: normalize(funds),
      withSearch: true,
      withRefresh: true,
      refreshList: () => dispatch(apiFinancialsList("fund", token)),
      footer: (
        <Footer
          title="افزودن تنخواه"
          type="financial"
          callBack={(token: any, res: any) => {
            dispatch(
              apiFinancialsList("fund", token, () => {
                handleChange({ val: res.id, key: "fund" });
              })
            );
          }}
        />
      ),
      closeOnFooterClick: true
    },
    cashier: {
      type: "select",
      label: "انتخاب صندوق",
      options: normalize(cashiers),
      withSearch: true,
      withRefresh: true,

      refreshList: () => dispatch(apiFinancialsList("cashier", token)),
      footer: (
        <Footer
          title="افزودن صندوق"
          type="financial"
          callBack={(token: any, res: any) => {
            dispatch(
              apiFinancialsList("cashier", token, () => {
                handleChange({ val: res.id, key: "cashier" });
              })
            );
          }}
        />
      ),
      closeOnFooterClick: true
    },
    person: {
      type: "select",
      label: "انتخاب شخص",
      options: [],
      withSearch: true,
      defaultValue: defaultValues.selectPersonDes ? defaultValues.selectPersonDes : undefined,
      withRefresh: true,
      name: "selectPersonDes",
      searchColumns: "nickName,firstName,accountingCode,lastName,mobile",
      requestInfo: { method: "get", url: "/persons/list/active" },
      beforeLoadingPerSelectBox: beforeLoadingPerSelectBox,
      onChange: async (val, option) => {
        handleChange({ val: val, key: "person" });
      },
      // refreshList: () => dispatch(apiPersonsList(token, "allPerson")),
      footer: (
        <Footer
          title="افزودن شخص"
          type="person"
          callBack={(token: any, res: any) => {
            dispatch(
              apiPersonsList(token, "customer", () => {
                setDefaultValues(state => { return { ...state, selectPersonDes: res.id } })
                handleChange({ val: res.id, key: "person" });
              })
            );
          }}
        />
      ),
      closeOnFooterClick: true
    },
    spendCheque: {
      type: "select",
      label: "انتخاب چک",
      options: (normalize(cheques) as Cheque[]).map((x) => ({
        ...x,
        dsc: `مبلغ: ${formatPrice(x.amount)} ${x.CurrencyId ? currencies.find((y) => y.id === x.CurrencyId)?.en_title : defCur.en_title
          }`,
        label: `${x.personName} - ${x.dueDate}`,
        value: x.id,
        searchKeys: [x.number].filter((x) => x).join(" "),
        footer: (
          <div className="flex flex-col gap-2 text-xs text-dark-3">
            {x.dueDate && <span>تاریخ سررسید: {x.dueDate}</span>}
            {x.number && <span>شماره چک: {x.number}</span>}
          </div>
        )
      })),
      withSearch: true,
      withRefresh: true,
      refreshList: () => dispatch(apiChequesList(token)),
      onChange: async (val, option) => {
        let d = await handleChange({ key: "spendCheque", val, option });
        await handleChange({ key: "price", val: option?.amount, d });
      },
      onClear: async () => {
        handleChange({ key: "spendCheque", val: undefined, removeTypeOption: true });
      }
    },
    cheque: {
      type: "select",
      label: "انتخاب پرداخت کننده",
      options: chequePayers[props.transactionType || "payment"],
      withSearch: true,
      withRefresh: true,
      refreshList: chequeRefreshList[props.transactionType || "payment"],
      footer: (
        <Footer
          title="افزودن پرداخت کننده"
          type="person"
          callBack={(token: any, res: any) => {
            dispatch(
              apiPersonsList(token, "customer", () => {
                handleChange({ val: res.id, key: "cheque" });
              })
            );
          }}
        />
      ),
      closeOnFooterClick: true
    },
    pos: {
      type: "select",
      label: "انتخاب دستگاه کارتخوان",
      options: posList,
      defaultValue: defaultPos?.id,
      defaultValues: [defaultPos?.id],
      forceCallChanged: true,
      withSearch: true,
      withRefresh: true,
      refreshList: () => {
        if (posList.length === 0) {
          dispatch(apiGetPos(token, (res: any) => {
            const list: any[] = normalize(res.data.pos)
            setPosList(list)

          }))
        }
      },
    },
    price: {
      type: "text",
      label: "مبلغ",
      inputProps: { type: "price", prefix: props.currency?.en_title }
    },


    wage: { type: "text", label: "کارمزد", inputProps: { type: "price", prefix: props.currency?.en_title } },
    sayad: { type: "text", label: "شماره صیاد" },
    chequeViewer: { type: "custom", children: ChequeViewer() },
    // dn: {
    //   type: "inline",
    //   inputs: [
    //     {
    //       type: "date",
    //       label: "تاریخ ( الزامی )",
    //       inputProps: { withoutClear: true },
    //       name: "date"
    //     },
    //     { type: "text", label: "شماره چک", name: "number", inputProps: { type: "number-native" } }
    //   ]
    // },
    // bb: {
    //   type: "inline",
    //   inputs: [
    //     { type: "text", label: "بانک صادرکننده", name: "issuingBank" },
    //     { type: "text", label: "شعبه", name: "branch" }
    //   ]
    // },
    number: { type: "text", label: "شماره چک", name: "number" },
    date: {
      type: "date",
      label: "تاریخ ( الزامی )",
      inputProps: { withoutClear: true },
      name: "date"
    },
    issuingBank: { type: "text", label: "بانک صادرکننده", name: "issuingBank" },
    branch: { type: "text", label: "شعبه", name: "branch" }
  };

  const options: CardProps["options"] = [
    {
      label: "بانک",
      value: "bank",
      icon: IconLogoBank,
      active: props.installmentOption ? props?.activeOption?.includes("bank") : true
    },
    {
      label: "شخص",
      value: "person",
      icon: IconLogoPerson2,
      active: props.installmentOption ? props?.activeOption?.includes("person") : true
    },
    {
      label: "چک",
      value: "cheque",
      icon: IconLogoCheque,
      active: props.installmentOption ? props?.activeOption?.includes("cheque") : true
    },
    {
      label: "خرج چک",
      value: "spendCheque",
      icon: IconLogoCheque,
      active: props.installmentOption
        ? props?.activeOption?.includes("spendCheque")
        : props.transactionType === "payment"
    },
    {
      label: "تنخواه",
      value: "fund",
      icon: IconLogoFund,
      active: props.installmentOption ? props?.activeOption?.includes("fund") : true
    },
    {
      label: "صندوق",
      value: "cashier",
      icon: IconLogoCashier,
      active: props.installmentOption ? props?.activeOption?.includes("cashier") : true
    },
    {
      label: "دستگاه کارت خوان",
      value: "pos",
      icon: posImg,
      active: props.installmentOption ? props?.activeOption?.includes("pos") : true
    }
  ];

  const inputsToShow: any = {
    bank: ["bank", "price", "wage"],
    person: ["person", "price"],
    pos: ["pos", "price"],
    // cheque: ["cheque", "price", "dn", "sayad", "bb"],
    cheque: ["cheque", "price", "number", "sayad", "date", "issuingBank", "branch"],
    spendCheque: ["spendCheque", "chequeViewer"],
    fund: ["fund", "price"],
    cashier: ["cashier", "price"]
  };

  const requiredInputs: any = {
    bank: ["bank", "price"],
    pos: ["pos", "price"],
    person: ["person", "price"],
    cheque: ["cheque", "price", "date"],
    spendCheque: ["spendCheque"],
    fund: ["fund", "price"],
    cashier: ["cashier", "price"]
  };

  const typeOptionKeys = ["bank", "fund", "cashier", "person", "cheque", "spendCheque", "pos"];
  const typeOption: any = data?.typeOption || {};

  function done(data: any) {
    let required = requiredInputs[type];
    const valid = !required?.find((x: any) => !data[x]);
    return valid;
  }

  function normalize(d: any[]) {
    // ``;
    if (!d) return [];

    const data = d.map((x: any) => {
      return {
        ...x,
        ind: x.accountingCode || x.id,
        title: x.title || x.nickName || x.name || x.personName,
        image: x.image || x.icon || x.imageUrl,
        value: x.value ? x.value : x.id,
        label: x.label ? x.label : x.title
      }
    })
    return data

  }

  const descriptions = {
    wage: (
      <div className="flex items-center gap-1">
        <PlusIcon color="green" scale={0.7} />
        <span className="text-base">{formatPrice(data.wage || 0)}</span>
        <span className="text-xs text-dark-3">{props.currency?.en_title}</span>
        <span>کارمزد بانک</span>
      </div>
    )
  };

  function Footer({ title, type, callBack }: { title: string; type: string; callBack?: any }) {
    return (
      <BasicButton
        onClick={() => {
          dispatch(
            appSetModal({
              component: type,
              title: title,
              closeButton: true,
              onFinish: (token: any, res: any) => {
                res && callBack && callBack(token, res);
              }
            })
          );
        }}
      >
        <PlusIcon scale={0.7} /> <span>{title}</span>
      </BasicButton>
    );
  }

  function ChequeViewer() {
    const c = data?.typeOption;
    if (!c) {
      return (
        <div className="flex w-full gap-4 p-4 bg-white border-r border-dashed shadow-md rounded-l-md border-slate-400">
          <div className="flex flex-col w-full gap-2">
            <div className="flex items-center justify-between gap-2">
              <div className="w-16 bg-gray-200 rounded-md h-7"></div>
              <div className="w-16 bg-gray-200 rounded-md h-7"></div>
            </div>
            <div className="w-full bg-gray-300 rounded-md h-7"></div>
            <div className="flex items-center gap-2">
              <div className="bg-gray-200 rounded-full min-w-[28px] h-7"></div>
              <div className="w-full bg-gray-200 rounded-md h-7"></div>
            </div>
          </div>
          <div className="min-w-[80px] border-r border-slate-400 flex justify-center items-center">
            <img src={ChequeImage} alt="" className="w-12" />
          </div>
        </div>
      );
    }
    return (
      <div className="flex w-full gap-4 p-4 bg-white border-r border-dashed shadow-md rounded-l-md border-slate-400">
        <div className="flex flex-col w-full gap-2">
          <div className="flex items-center justify-between gap-2 mb-5">
            <div className="flex items-center gap-2 p-1 rounded-md bg-blue-5 h-7">
              <HashtagIcon />
              <span className="text-blue-1">{c.accountingCode}</span>
            </div>
            <div className="flex items-center h-7">{c.dueDate}</div>
          </div>
          <div className="flex items-center justify-center w-full gap-2 h-7">
            <span className="text-[28px] text-dark-1">{formatPrice(c.amount)}</span>
            <span className="text-[20px] text-dark-3">
              {c.CurrencyId ? currencies?.find((x) => x.id === c.CurrencyId)?.en_title : defCur.en_title}
            </span>
          </div>
          <div className="flex items-center justify-center w-full gap-2">
            <div className="bg-blue-5 rounded-full min-w-[28px] h-7">
              <img src={autograph} alt="" className="w-full" />
            </div>
            <div className="flex items-center gap-2 h-7">
              <span>{c.personAccountingCode}</span>
              <span>-</span>
              <span>{c.title}</span>
            </div>
          </div>
        </div>
        <div className="min-w-[80px] border-r border-slate-400 flex justify-center items-center">
          <img src={ChequeGreenImage} alt="" className="w-12" />
        </div>
      </div>
    );
  }

  function handleChange(p?: { val?: any; key?: any; option?: any; d?: any; removeTypeOption?: boolean }) {
    return new Promise((resolve) => {
      const { key, option, removeTypeOption } = p || {};
      let val = p?.val;
      let d = p?.d || data;
      if (Array.isArray(val)) {
        val = val[0];
      }
      let typeOption;
      if (typeOptionKeys.includes(key) && option) {
        typeOption = option;
      }
      const newData = {
        ...d,
        [key]: val,
        ...(!!typeOption && { typeOption }),
        ...(removeTypeOption && { typeOption: undefined })
      };
      setData(newData);
      props.onChange &&
        props.onChange({
          data: newData,
          type,
          icon: options?.find((x) => x.value === type)?.icon,
          ...(!!typeOption && { typeOption }),
          ...(removeTypeOption && { typeOption: undefined }),
          done: done(newData)
        });
      resolve(newData);
    });
  }

  function handleTypeChange(val: any) {
    setType(val);
    setData({});
    const price = transactionsPrice === totalPrice ? defPrice : (defPrice ? defPrice : 0) - (transactionsPrice ? transactionsPrice : 0)
    props.onChange && props.onChange({ data: { price }, type: val, done: false });
  }
  return (
    <ClickAwayListener
      onClickAway={() => {
        if (done(data) && !!edit) {
          setEdit(false);
          props.onChangeEdit && props.onChangeEdit(false);
        }
      }}
    >
      <div>
        <Card
          {...{
            inputs,
            inputsToShow,
            options,
            extraFooterBtn: extraFooterBtn,
            data,
            type,

            onTypeChange: handleTypeChange,
            onChange: (data) => handleChange({ ...data }),
            onChangeEdit: (edit) => props.onChangeEdit && props.onChangeEdit(edit),
            onDelete: props.onDelete,
            edit,
            index: props.index,
            currency: props.currency,
            info: {
              icon: options.find((x) => x.value === type)?.icon || "",
              dsc: data.wage ? descriptions.wage : <></>,
              price: data.price || 0,
              title: typeOption.title,
              ind: typeOption.accountingCode,
              isPositive: props.tab === 1
            },
            justShow: props.justShow
          }}
        />
      </div>
    </ClickAwayListener>
  );
}
